resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    Radio

    Radio extends the functionality of an existing set of radio buttons to allow state management.

    HTML Structure:
        An <input> with data-mogo-ui variable set to "Radio"

        E.g; 

            input(data-mogo-ui="Radio" type="radio" name="my_name" placeholder="my_label" value="my_value")

    Arguments:
        disabled (optional) [boolean]:
            Determines if the radio control is initially disabled.
        checked (optional) [boolean]:
            Determines if the radio control is initially selected.

    Methods:
        setChecked(value)
            arguments: value
            selects / deselects the radio control
        val(value)
            arguments: value
            returns the value of the radio control if it is selected or, if value == true, sets the radio
            control state to selected

*/
function Radio() {
    this.extends = [_Input];
    this.node = null;
    this.id = null;
    this.containerDiv = null;
    this.inputContainerDiv = null;
    this.radioButtonDiv = null;
    this.labelDiv = null;
    this.group = null;

    this.placeholder = "";
    this.disabled = false;
    this.checked = false;

    this.init = function() {
        if (this.node.tagName.toLowerCase() == "input") {
            if ($(this.node).attr("type").toLowerCase() != "radio") $(this.node).attr("type", "radio");
            
            // build nodes
            this.containerDiv = $("<div class='mogo-ui-radio'></div>").insertBefore(this.node)[0];
            this.inputContainerDiv = $("<div class='input-container'></div>")[0];
            this.labelDiv = $("<label for='" + this.id + "'>&nbsp;</div>").appendTo(this.containerDiv)[0];

            if ($(this.node).attr("placeholder")) this.placeholder = $(this.node).attr("placeholder");
        } else if (this.node.tagName.toLowerCase() == "div") {

            // get data and empty the component
            $(this.node).addClass("mogo-ui-radio");
            this._placeholder = $(this.node).attr("placeholder");
            this._content = $(this.node).contents(); // jquery objects array not raw html
            $(this.node).empty();

            // set the container
            this.containerDiv = this.node;
            this._attributes = this.containerDiv.attributes;
            $(this.containerDiv).removeAttr('id');

            // setup the input container
            this.inputContainerDiv = $("<div class='input-container'></div>")[0];
            
            // setup the div contents
            this._label = $('<label for="'+ this.id +'">'+ this._placeholder +'</label>');
            this._describedBy = $('<div id="'+ this.id +'_describedby"></div>');
            $(this._describedBy).append(this._content);
            $(this.containerDiv).append(this._label);
            $(this.containerDiv).append(this._describedBy);

            // make the this.node the input
            this.node = $('<input id="'+ this.id +'" aria-describedby="'+ this.id +'_describedby" type="radio" />')[0];
            
            // setup custom click handlers for div specific usage
            $(this.node).on('click.radio',   function(e) { e.stopPropagation(); });
            $(this._label).on('click.radio', function(e) { e.stopPropagation(); });
            $(this.containerDiv).on('click.radioContainer', this._containerDivClickEvent.bind(this));

            // setup the attributes
            for (var i = this._attributes.length - 1; i >= 0; i--) {
                var attribute = this._attributes[i];
                if (attribute.name != "class" && attribute.name != "style" && attribute.name != "id") {
                    $(this.node).attr(attribute.name, attribute.value);
                    $(this.containerDiv).removeAttr(attribute.name);
                }
            }
        }

        // build node structure
        $(this.containerDiv).prepend(this.inputContainerDiv);
        $(this.node).appendTo(this.inputContainerDiv);

        // setup the radio button
        this.radioButtonDiv = $("<div class='radio-button'></div>").prependTo(this.inputContainerDiv)[0];
        $("<div class='checked'></div>").appendTo(this.radioButtonDiv);

        if ($(this.node).attr("name"))
            this.group = $(this.node).attr("name");
        else
            this.group = $(this.node).attr("name", this.id);

        if (this.placeholder != "") {
            $(this.labelDiv).html(this.placeholder);
        }

        if (this.node.checked) {
            this.checked = true;
            $("[name='" + this.name + "']").removeClass("selected");
            $(this.containerDiv).addClass("selected");
        }

        if (this.node.disabled) {
            $(this.containerDiv).addClass("disabled");
        }

        // Connections
        $(this.node).on("change", $.proxy(this._onNodeChange, this));
        $(this.node).on("focus", $.proxy(this._onFocus, this));
        $(this.node).on("blur", $.proxy(this._onBlur, this));
        $(this.radioButtonDiv).on("click", $.proxy(this._onRadioButtonClick, this));

        $(this.node).css("display", "block");
    };

    this.initAllReady = function() {};

    this._containerDivClickEvent = function() {
      $(this.node).trigger('click.script');
    };

    /*
        Selected or deselects the radio control.

        Arguments:
            value (optional) [boolean]:
                Whether to select the radio control (true) or not.

    */
    this.setChecked = function(value) {
        if (typeof value == "boolean") {
            this.checked = value;
            this.node.checked = value;
            if (this.checked) {
                var otherRadios = $("[name='" + this.group + "']");
                for (var i = 0; i < otherRadios.length; i++)
                    $($(otherRadios[i]).parents(".mogo-ui-radio")[0]).removeClass("selected");
                $(this.containerDiv).addClass("selected");
            } else {
                $(this.containerDiv).removeClass("selected");
            }
        }
    };

    /*
        If a boolean value is provided, the radio control will be selected or deselected accordingly.
        Otherwise, the current selected state of the radio control will be returned.

        Arguments:
            value (optional) [boolean]:
                Whether to select (true) or deselect (false) the radio control.

        Returns:
            [boolean]
                true, if no argument is provided and the radio control is selected.
                Null otherwise.
    */
    this.val = function(value) {
        if (value == null) {
            if ($(this.node)[0].checked)
                return $(this.node).val();
            else
                return null;
        } else {
            this.setChecked(value);
        }
    };

    this._onNodeChange = function(evt) {
        this.setChecked(this.node.checked);
    };

    this._onRadioButtonClick = function(evt) {
        $(this.node).click();
    };

    this._onFocus = function(evt) {
        $(this.containerDiv).addClass("focused");
    };

    this._onBlur = function(evt) {
        $(this.containerDiv).removeClass("focused");
    }
}
